import type { RecentListItem } from './recent-values-types'

export function sameItem(a: RecentListItem, b: RecentListItem): boolean {
  return Object.is(a, b)
}

/** New value first; duplicates removed; trimmed to `maxItems`. */
export function recordList(
  prev: RecentListItem[],
  value: RecentListItem,
  maxItems: number
): RecentListItem[] {
  return [value, ...prev.filter((v) => !sameItem(v, value))].slice(0, maxItems)
}

export function removeListItem(prev: RecentListItem[], value: RecentListItem): RecentListItem[] {
  return prev.filter((v) => !sameItem(v, value))
}
